// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.rewards.EnrollRewardsUserWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { EnrollRewardsUserWebApiResponseDto } from '../..';

export const EnrollRewardsUserWebApiHandler_enrollUser_Path = '/api/web/v1/rewards/enrollUser';

/**
 * enroll user into rewards program
 */
export const EnrollRewardsUserWebApiHandler_enrollUser = (client = getClient()) => {
  return httpFrontEndRequest<never, never, EnrollRewardsUserWebApiResponseDto>(
    {
      endpoint: EnrollRewardsUserWebApiHandler_enrollUser_Path,
      method: 'POST',
      contextPath: '/rent-payment',
    },
    client,
  );
};
